$('.faq-wrapper .faq-item .h5').on('click', function () {
    var $wrapper = $(this).closest('.faq-wrapper');
    var $item = $(this).closest('.faq-item');

    if ($item.hasClass('open')) {
        $item.removeClass('open');
    } else {
        $wrapper.find('.faq-item').removeClass('open');
        $item.addClass('open');
    }
});
